import script from "./ourworkDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ourworkDetail.vue?vue&type=script&setup=true&lang=js"

import "./ourworkDetail.vue?vue&type=style&index=0&id=5db19ffa&lang=less"
import "./ourworkDetail.vue?vue&type=style&index=1&id=5db19ffa&lang=less&scoped=true"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db19ffa"]])

export default __exports__